import { Button, CircularProgress } from "@mui/material"
import globals from "../globals";

const RedButton = ({ text, mTop, pX, href, size, sx, onClick, disabled, startIcon, loading = false }) => {
    return (
        <Button
            variant='contained'
            href={href}
            onClick={onClick}
            type='submit'
            size={size || 'large'}
            disabled={disabled || loading}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : startIcon}
            sx={{
                mt: mTop,
                px: pX,
                fontWeight: 'none',
                backgroundColor: globals.colors.lightRed,
                textTransform: 'none',
                '&:hover': { backgroundColor: globals.colors.darkRed },
                ...(sx || {})
            }}
        >
            {text}
        </Button>
    );
}

export default RedButton;